module.exports = __webpack_public_path__ + "static/es-342d52e10a9caa9260dfdc3216cd507a.png";